import React, { useState, createContext, useEffect, useContext } from "react";
import { useNavigate } from 'react-router-dom';

import axios from 'api/axios';
import { ContextBlock } from "./ContextBlock";
import { ContextTraining } from "./ContextTraining";

const ContextTrainingSearchResult = createContext();

const TrainingSearchResultProvider = ({ children }) => {
  const navigate = useNavigate();

  const TRAINING_URL = 'training';
  const TRAINING_SEARCH_RESULT_URL = 'search/result';

  //params context
  const { 
    setOpenSnackBar, 
    setSnackBarType, 
    setSnackBarMessage 
  } = useContext(ContextBlock);
  
  const { 
    trainingId,
    training,
    TRAINING_STATUS_VALIDE,
    trainingSessionStaffingRows, setTrainingSessionStaffingRows
  } = useContext(ContextTraining);
  
  useEffect(() => {
    if (trainingSessionStaffingRows.length <= 0 && training.status && training.status?.code !== TRAINING_STATUS_VALIDE) {
      loadSearchResult();
    }
  }, [training]);
  
  const loadSearchResult = async () => {
    try {
      //config call API
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }
      }
      const response = await axios.get(`${TRAINING_URL}/${trainingId}/${TRAINING_SEARCH_RESULT_URL}`, config);
      //init rows
      setTrainingSessionStaffingRows(response.data?.data);
    } catch (err) {
      console.log(err);
      if (err.response?.status === 401) {
        navigate('/deconnexion');
      }
      else {
        setSnackBarMessage('Erreur technique! Veuillez réessayer ou contacter notre support.');
        setSnackBarType('error');
        setOpenSnackBar(true);
      }
    }
  }

  return (
    <ContextTrainingSearchResult.Provider
    value={{ }}>
      {children}
    </ContextTrainingSearchResult.Provider>
  );
};

export { TrainingSearchResultProvider, ContextTrainingSearchResult };
